import styled from 'styled-components';

// TODO: Consider removing this wrapper altogether. This is a pre-packaged solution. Instead
// whomever renders the chart should be the one to worry about creating a wrapper -the right way-
export const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 25px); /* WARNING: this overflows the into the padding */
`;
